import { render, staticRenderFns } from "./workStart1.vue?vue&type=template&id=4ea8d426&scoped=true&"
import script from "./workStart1.vue?vue&type=script&lang=js&"
export * from "./workStart1.vue?vue&type=script&lang=js&"
import style0 from "./workStart1.vue?vue&type=style&index=0&id=4ea8d426&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea8d426",
  null
  
)

export default component.exports